import register from 'preact-custom-element';
import { dollarsToCents } from '../../../frontend/scripts/utils';

const ProductMainPrice = ({
  price,
  compareAtPrice,
  regularPriceLabel,
  salePriceLabel
}) => {
  const showCompareAtPrice = dollarsToCents(compareAtPrice) > dollarsToCents(price)

  return (
    <p>
      {showCompareAtPrice ? (
        <>
          <span class="sr-only">
            {regularPriceLabel}
          </span>
          <s class="mr-2">{compareAtPrice}</s>
          <span class="sr-only">
            {salePriceLabel}
          </span>
          <strong>{price}</strong>
        </>
      ) : (
        <span>{price}</span>
      )}
    </p>
  )
}

register(ProductMainPrice, 'product-main-price', ['price', 'compare-at-price'])
